export function createBaseFormTemplate(
  listHeader: any,
  customListSchema: any,
  conditionFilters:any
): any {
  return {
    type: "fgcardContainer",
    name: "Card Container",
    icon: "fa fa-columns",
    config: true,
    condition: {},
    isCoreConfig: true,
    children: [
      {
        type: "fgCardHeader",
        name: "Card Header",
        icon: "fa fa-square-o",
        config: true,
        class: "card-header",
        children: [listHeader],
        condition: {},
        isCoreConfig: true,
        category: "LAYOUT",
        isHiddenInCategory: true,
        uuid:crypto.randomUUID(),
      },
      {
        type: "fgCardBody",
        name: "Card Body",
        icon: "fa fa-square-o",
        config: true,
        class: "card-body",
        children: [
         {

            type: "fgcustomcontainer",
            name: "Custom Container",
            icon: "fa fa-square-o",
            class: "card-default",
            header: true,
            heading: "some heading",
            config: true,
            children: [
              {
                type: "fgListPage",
                subtype: "list",
                cat: "fgListPage",
                icon: "fa fa-list",
                name: "List Page",
                options: {},
                condition: {},
                isCoreConfig: true,
                category: "INPUT",
                uuid: crypto.randomUUID(),
                option: {
                  page: {
                    subTypeCode: "ALL_DATA_TYPES",
                  },
                  conditions: conditionFilters,
                },
                styles: {},
                showEmptyState: true,
                listSchema: JSON.stringify(customListSchema),
              },
            ],
            condition: {},
            isCoreConfig: true,
            category: "LAYOUT",
            uuid: crypto.randomUUID(),
            parentContainer: true,
          },
        ],
        condition: {},
        isCoreConfig: true,
        category: "GENERAL",
        isHiddenInCategory: true,
        uuid: crypto.randomUUID(),
      },
      {
        type: "fgCardFooter",
        name: "Card Footer",
        icon: "fa fa-square-o",
        config: true,
        class: "card-footer",
        children: [],
        condition: {},
        isCoreConfig: true,
        category: "GENERAL",
        isHiddenInCategory: true,
        uuid:crypto.randomUUID(),
      },
    ],
    category: "LAYOUT",
    disableAdd: true,
    uuid: crypto.randomUUID(),
    styles: {},
  };
}
